import { typedQueryClient, useTypedQuery } from "hooks";
import { TyresDashboardQueryKeys } from "modules/TyresDashboard/queryKeys";
import { TYRES_STORAGE_KEYS } from "modules/TyresDashboard/storageKeys";
import { PAGE_SIZE, getPreference, setPreference } from "utils/common";

import type { TyreFilters } from "modules/TyresDashboard/queryKeys";

export const DEFAULT_TYRE_FILTERS: TyreFilters = {
  page: 1,
  page_size: PAGE_SIZE.PageSize25,
  manufacturer: null,
  description: null,
  ean: null,
  carry_capacity: null,
  width: null,
  height: null,
  size: null,
  speed: null,
  season: null
};

const getInitialTyreFilters = (): TyreFilters => ({
  ...DEFAULT_TYRE_FILTERS,
  page_size: getPreference(TYRES_STORAGE_KEYS.PageSizePreference, DEFAULT_TYRE_FILTERS.page_size),
  manufacturer: getPreference(TYRES_STORAGE_KEYS.ManufacturerPreference, DEFAULT_TYRE_FILTERS.manufacturer),
  description: getPreference(TYRES_STORAGE_KEYS.DescriptionPreference, DEFAULT_TYRE_FILTERS.description),
  ean: getPreference(TYRES_STORAGE_KEYS.EanPreference, DEFAULT_TYRE_FILTERS.ean),
  carry_capacity: getPreference(TYRES_STORAGE_KEYS.CarryCapacityPreference, DEFAULT_TYRE_FILTERS.carry_capacity),
  width: getPreference(TYRES_STORAGE_KEYS.WidthPreference, DEFAULT_TYRE_FILTERS.width),
  height: getPreference(TYRES_STORAGE_KEYS.HeightPreference, DEFAULT_TYRE_FILTERS.height),
  size: getPreference(TYRES_STORAGE_KEYS.SizePreference, DEFAULT_TYRE_FILTERS.size),
  speed: getPreference(TYRES_STORAGE_KEYS.SpeedPreference, DEFAULT_TYRE_FILTERS.speed),
  season: getPreference(TYRES_STORAGE_KEYS.SeasonPreference, DEFAULT_TYRE_FILTERS.season)
});

const persistTyreFilters = (filters: TyreFilters) => {
  setPreference(TYRES_STORAGE_KEYS.PageSizePreference, filters.page_size);
  setPreference(TYRES_STORAGE_KEYS.ManufacturerPreference, filters.manufacturer);
  setPreference(TYRES_STORAGE_KEYS.DescriptionPreference, filters.description);
  setPreference(TYRES_STORAGE_KEYS.EanPreference, filters.ean);
  setPreference(TYRES_STORAGE_KEYS.CarryCapacityPreference, filters.carry_capacity);
  setPreference(TYRES_STORAGE_KEYS.WidthPreference, filters.width);
  setPreference(TYRES_STORAGE_KEYS.HeightPreference, filters.height);
  setPreference(TYRES_STORAGE_KEYS.SizePreference, filters.size);
  setPreference(TYRES_STORAGE_KEYS.SpeedPreference, filters.speed);
  setPreference(TYRES_STORAGE_KEYS.SeasonPreference, filters.season);
};

export const useTyresFilters = () => useTypedQuery({ queryKey: TyresDashboardQueryKeys.filters, initialData: getInitialTyreFilters }).data;

export const setTyresFilters = (filters: Partial<TyreFilters>) => {
  const previousFilters = typedQueryClient.getQueryData(TyresDashboardQueryKeys.filters);
  if (!previousFilters) return;

  const newFilters = { ...previousFilters, ...filters };
  persistTyreFilters(newFilters);

  typedQueryClient.setQueryData(TyresDashboardQueryKeys.filters, newFilters);
};
